@if (courseId || quiz) {
<div class="quiz-statistics">
  @if (!showQuestionStats) {
  <div class="quiz-statistics-container">
    <ng-scrollbar>
      <div class="stat-container">
        <div class="datepicker date-picker-container">
          <qa-button
            (submitted)="downloadExcel()"
            label="content.quiz.questionStatistics.downloadAsExcel"
          ></qa-button>
          <qa-custom-range-picker> </qa-custom-range-picker>
        </div>
        <div [class.faded]="loading" class="chart-container">
          @if (chartData) {
          <qa-chart
            [data]="chartData"
            [options]="chartOptions"
            chartType="line"
            #chart
          >
          </qa-chart>
          }
          <div class="quiz-stat-container">
            <div class="quiz-statistics-title">
              {{
                'content.quiz.questionStatistics.questionStatisticTitle'
                  | translate
              }}
            </div>
            @if (questionsOverview) {
            <div class="quiz-statistics-table">
              <qa-question-overview-list
                [questions]="questionsOverview"
                [hideUnAnswered]="true"
                (selectQuestionResult)="getQuestionStatistic($event)"
              ></qa-question-overview-list>
            </div>
            }
          </div>
        </div>
      </div>
    </ng-scrollbar>
  </div>
  } @if (showQuestionStats && questionStatistics) {
  <div class="question-stats-container">
    <qa-question-overview-details
      [question]="question"
      [loading]="loading"
      [hideUnAnswered]="true"
      [allQuestions]="questionsOverview"
      [getQuestionResult]="getQuestionStatistic.bind(this)"
      [currentItemIndex]="currentItemIndex"
      (goBack)="showQuestionStats = false"
    >
    </qa-question-overview-details>
  </div>
  }
</div>
}
